module.exports = __webpack_public_path__ + "static/img/7498_phase_function_Paper_PointsHejduk_Prediction.55f298f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7498_phase_function_Paper_PointsHejduk_Prediction.png
// module id = v8YY
// module chunks = 0